// removed by extract-text-webpack-plugin
module.exports = {"business-contents":"business-contents","business-content":"business-content","business-content-title":"business-content-title","business-content-detail":"business-content-detail"};


//////////////////
// WEBPACK FOOTER
// ./components/business/business-page/styles/_business-content.scss
// module id = ./components/business/business-page/styles/_business-content.scss
// module chunks = 0